import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/WRI_HOMEPAGE.mp4")